import { render } from "./AdittionaService.vue?vue&type=template&id=e0b27e64&scoped=true"
import script from "./AdittionaService.vue?vue&type=script&lang=js"
export * from "./AdittionaService.vue?vue&type=script&lang=js"

import "./AdittionaService.vue?vue&type=style&index=0&id=e0b27e64&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b27e64"]])

export default __exports__